import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useRef , useEffect} from 'react';
import {isMobileOnly} from 'react-device-detect';
import { remove, uniq, filter, forEach, findIndex } from 'lodash';
import Slider from "react-slick";
import CheckBtn from '../common/button/CheckBtn';
import { setEsMySelBrandStep3Action } from '../../modules/es/esMyModule';

const MyEsBrandItemBlock = styled.div`
    border-radius: 12px;
    border: ${props => props.border};//solid 1.4px #666666;
    width: 100%;
    color: #333333;
    padding: 16px;
    margin-top: 20px;

    .title-container {
        margin-left: 10px;
        ${isMobileOnly?`
        width: calc(92vw - 200px);
        `:`
        width: 430px;
        `};
    }

    .title {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        //max-height: 50px;
        margin-bottom: 4px;
    }

    .price {
        ${isMobileOnly?`
        font-weight: 500;
        `:`
        font-weight: 500;
        `};
        font-size: 22px;
        
        line-height: 27px;
        //max-height: 50px;
    }

    .price-label {font-size: 12px; font-weight: 400;}
  
    .won {
        font-size: 16px;
        font-weight: normal;
    }

    .wave {
        font-size: 16px;
        font-weight: 500;
    }

    .brief {
        font-size: 12px;
        font-weight: normal;
        line-height: 1.5;
        margin-bottom: 8px;
    }

    .cate-container {
        font-size: 12px;
        font-weight: normal;
        line-height: 1.5;
        color: #999999;

        /* display: -webkit-box;
        -webkit-line-clamp: 2;
        //max-height: 30px;
        -webkit-box-orient: vertical;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
        word-break: break-all; */
        overflow: hidden;
        
        ${isMobileOnly?`
        max-height: 36px;
        `:`
        max-height: 16px;
        `};
    }
    .cate {
        
        float: left;
        position: relative;

        ::after {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            bottom: 3px;
            height: 8px;
            background-color: #f4f4f4;
            z-index: -1;
            width: 100%;
        }
    }

    .slick-list {
        width: 120px;
        height: 120px;
        border-radius: 12px;
        object-fit: cover;
    }

    .slick-dot{
        border-radius: 50%;
        float: left;
        position: relative;
        
    }

    .slick-dots {
        top: -16px;
        position: relative;
        margin: 0 auto;
        display: flex;
        justify-content: center;

        li {
            position: relative;
            float: left;
            margin-right: 6px;
        }

    }

`;

const MyEsBrandItemSlideBlock = styled.div`
    width: 120px;
    height: 120px;
    position:relative;
`;

const MyEsBrandItem = ({info, selBrand, handleSelBrand, availCnt}) => {
    const dispatch = useDispatch();
    //const [active, setActive] = useState(false);
    const refBlock = useRef(null);
    const [count, setCount] = useState(0);
    const [curSlide, setCurSlide] = useState(0);

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: isMobileOnly?1:1,  // 1 slide if mobile
        slidesToScroll: 1,
        variableWidth: false,
        arrows: false,
        //swipeToSlide: true,
        beforeChange: (prev, next) => {   // here to detect slide change
            setCurSlide(next);
          },
          appendDots: dots => {
            return <ul className="slick-dots" style={{ margin: "0px" }}>{dots}</ul>;
          },
          customPaging: (pagi, i) => {
            const style = {
              width: 4,
              height: 4,
              display: "inline-block",
              //backgroundImage: `url(../navigator.png )`, // need to change as navigator-active.png this when active
              backgroundSize: 'contain',
              backgroundRepeat: "no-repeat",
              backgroundColor: '#ffffff',
              boxShadow: '0 0 2px 0 rgb(0 0 0 / 20%)',
              opacity: 0.6,
              float: 'left',

            };
            const activeStyle = {
              width: 6,
              height: 6,
              display: "inline-block",
              //backgroundImage: `url(../navigator-active.png )`,
              backgroundSize: 'contain',
              backgroundRepeat: "no-repeat",
              backgroundColor: '#ffffff',
              boxShadow: '0 0 2px 0 rgb(0 0 0 / 20%)',
              opacity: 0.9,
              float: 'left',
              top: '-1px',
            };
            return (
              <div
                className="slick-dot"
                style={pagi === curSlide ? activeStyle : style}
              />
            );
          }
      };

    const { esMyBrandCate1Step, esCate2Name, esSelBrandStep3 } = useSelector(
        ({ esMyReducer }) => ({
            esMyBrandCate1Step: esMyReducer.esMyBrandCate1Step,
            esCate2Name: esMyReducer.esCate2Name,
            esSelBrandStep3: esMyReducer.esSelBrandStep3,
        })
    );

    useEffect(() => {


    }, []);


    const getCateName = () => {
        if(esCate2Name && esCate2Name.length>0){
            let idx = findIndex(esCate2Name, (curitem) => {
                //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                return curitem.brandId*1 === info.brand.brnd_id*1;
            })

            if(idx >= 0) {
                let cateitems = esCate2Name[idx].cate;
                let cateText = "";
                forEach(cateitems, (cate, index) => {
                    if(index === 0) {
                        cateText = "<span class='cate'>" + cate + "</span>";
                    } else {
                        //cateText = cateText+"・"+cate;
                        cateText = cateText + "<span class='cate'>" + "・" + cate + "</span>"
                    }

                });
                //let test = '<span style="color:red">COLOR RED</span>';
                //let test2 = document.createElement('span'); // body에 추가할 span 태그를 추가
                //test2.innerHTML = cateText;

                return cateText;
            }
        }
    }

    const getCateString = () => {
        if(esCate2Name && esCate2Name.length>0){
            let idx = findIndex(esCate2Name, (curitem) => {
                //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                return curitem.brandId*1 === info.brand.brnd_id*1;
            })

            if(idx >= 0) {
                let cateitems = esCate2Name[idx].cateId;
                let cateText = "";
                forEach(cateitems, (cate, index) => {
                    if(index === 0) {
                        cateText = cate + " ";
                    } else {
                        //cateText = cateText+"・"+cate;
                        cateText = cateText + " " + cate;
                    }

                });
                //let test = '<span style="color:red">COLOR RED</span>';
                //let test2 = document.createElement('span'); // body에 추가할 span 태그를 추가
                //test2.innerHTML = cateText;

                return cateText;
            }
        }
    }

    const handleCheckClick = (value) => {

        //console.log("handleCheckClick = "+ JSON.stringify(esSelBrandStep3))
        if(selBrand === null || selBrand === undefined ) {
            return;
        }

        if(info === null || info === undefined) {
            return ;
        }

        if(handleSelBrand === null || handleSelBrand === undefined) {
            return;
        }

        let cate = getCateString();
        handleSelBrand(info.brand.brnd_id, info.brand.brnd_han, cate);
    }

    const getCheckStatus = () => {
        let ret = false;
        let ret2 = true;

        let countSoldOut = 0;

        if(selBrand === null || (selBrand && selBrand.length < 1)) {
            return ret;
        }

        if(info === null || info === undefined) {
            return ret;
        }

        let idx = findIndex(selBrand, (curitem) => {
            return curitem.brnd_id*1 === info.brand.brnd_id;
        })

        //console.log("idx = " + idx + " id="+info.brand.brnd_id)
        if(idx >= 0) {
            return ret2;
        }

        return ret;
    }

    return (
        isMobileOnly?
        <MyEsBrandItemBlock className="step3-brand" border={getCheckStatus()? 'solid 1.4px #666666':'solid 1.4px #cccccc'}>
            <div className="clearfix margin_b-10">
                <MyEsBrandItemSlideBlock className="f-left clearfix slide-image">
                    <div className = "si-list slick-initialized slick-slider ">
                        <Slider  {...settings} >
                                {
                                    info.products.map((curitem, index) => {

                                        return <img key={index} src={curitem.repr_img} className="slide-image2"></img>
                                    })
                                }
                        </Slider>
                    </div>
                </MyEsBrandItemSlideBlock>
                <div className="f-left title-container">
                    <div className="title">
                        {info.brand.brnd_han}
                    </div>
                    <div className="price-label">견적시작가</div>
                    <div className="price">
                        {Number(info.minprice.toFixed(1)).toLocaleString()}
                        <span className="won">원 </span>
                        <span className="wave">~</span>
                    </div>
                </div>
                <div className="f-right ">
                    <CheckBtn onClick={handleCheckClick} defaultValue={getCheckStatus()} disable={availCnt===selBrand.length&&!getCheckStatus()? true:false}/>
                </div>
            </div>
            <div className="brief">{info.brand.brnd_info_brief}</div>
            <div className="cate-container ">{<div dangerouslySetInnerHTML={{ __html: getCateName() }}/>}</div>
        </MyEsBrandItemBlock>
        :
        <MyEsBrandItemBlock className="step3-brand" border={getCheckStatus()? 'solid 1.4px #666666':'solid 1.4px #cccccc'}>
            <div className="clearfix">
                <MyEsBrandItemSlideBlock className="f-left clearfix slide-image">
                    <div className = "si-list slick-initialized slick-slider ">
                        <Slider  {...settings} >
                                {
                                    info.products.map((curitem, index) => {

                                        return <img key={index} src={curitem.repr_img} className="slide-image2"></img>
                                    })
                                }
                        </Slider>
                    </div>
                </MyEsBrandItemSlideBlock>
                <div className="f-left title-container">
                    <div className="title">
                        {info.brand.brnd_han}
                    </div>
                    <div className="price-label">견적시작가</div>
                    <div className="price margin_b-20">
                        {Number(info.minprice.toFixed(1)).toLocaleString()}
                        <span className="won">원 </span>
                        <span className="wave">~</span>
                    </div>
                    <div className="brief">{info.brand.brnd_info_brief}</div>
                    <div className="cate-container ">{<div dangerouslySetInnerHTML={{ __html: getCateName() }}/>}</div>
                </div>
                <div className="f-right ">
                    <CheckBtn onClick={handleCheckClick} defaultValue={getCheckStatus()} disable={availCnt===selBrand.length&&!getCheckStatus()? true:false}/>
                </div>
            </div>

        </MyEsBrandItemBlock>
    );
};

export default MyEsBrandItem;
